/**
Copyright (C) 2019-2025, Infraclear Inc. All Rights Reserved.
*/

import instance from '../../../utils/axiosInstance';
import {
  AdminUsageUser,
  AdminUsageTeam,
  AdminUsageSummary,
} from '../../../constants/api-urlConstants';
import { UserCostRollup, TeamCostRollup, UsageSummary } from './types';

export const fetchUserUsage = (
  userId: number,
  from: string,
  to: string
): Promise<UserCostRollup> => {
  return instance
    .get(AdminUsageUser(userId), { params: { from, to } })
    .then((response) => response.data.data ?? response.data);
};

export const fetchTeamUsage = (
  teamId: number,
  from: string,
  to: string
): Promise<TeamCostRollup> => {
  return instance
    .get(AdminUsageTeam(teamId), { params: { from, to } })
    .then((response) => response.data.data ?? response.data);
};

export const fetchUsageSummary = (
  from: string,
  to: string
): Promise<UsageSummary> => {
  return instance
    .get(AdminUsageSummary, { params: { from, to } })
    .then((response) => response.data.data ?? response.data);
};
